import FJAdvertising from './FJAdvertising';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import FJActionCommunity from '../../../../redux/action/FJActionCommunity';
import { useDispatch } from 'react-redux';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJLocalStore from '../../../../store/FJLocalStore';
import { useMemo } from 'react';

const FJAdvertisingContainer = () => {
    const dispatch = useDispatch();
    useLocalStore();
    const advertisingList = useSelector(state => state.community.advertisingList);
    const tag = FJLocalStore.currentTag();

    useEffect(() => {
        dispatch(FJActionCommunity.initAdvertisingListAction());
    }, [dispatch]);
    const list = useMemo(() => {
        return advertisingList
            .map(item => {
                return {
                    ...item,
                    desc: item.desc[tag],
                };
            })
            .filter(item => item.desc);
    }, [advertisingList, tag]);
    if (!list || list.length === 0) {
        return null;
    }
    return <FJAdvertising list={list} />;
};

export default FJAdvertisingContainer;
